<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeSlotStatus
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=15835-95475
 */
import type { BadgeSlotStatusProps } from '../types/interfaces'

import { useBadgeSlotStatus } from '../composables/use-badge-slot-status.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeSlotStatus',
})

const props = defineProps<BadgeSlotStatusProps>()

const {
  color,
  text,
} = useBadgeSlotStatus({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
